import React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, Avatar, Dropdown, Menu, Icon, Modal } from 'antd';
import { form_item_size } from '@common/theme';
import { Layout } from 'antd';

import SubstituteChargeModal, { substitute_charge_store } from './SubstituteChargeModal';

import go_to_page from '@common/GoToPage';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';

const { Header } = Layout;
const confirm = Modal.confirm;

@observer
class GlobalHeader extends React.Component {
  constructor() {
    super();
    this.state = {someKey: 'someValue'};
  }

  logout = () => {
    login_user_store.logout();
  }

  render() {
    const globalHeaderStyle = {
      position: 'relative',
      background: '#114abc',
      boxShadow: '0 1px 4px rgba(0, 21, 41, 0.08)',
      zIndex: '2',
      padding: '0 24px',
      color: '#fff'
    }
    return (
      <Header style={globalHeaderStyle}>
        <SubstituteChargeModal />
        <Row>
          <Col span={ 12 }>
            <Avatar size="small" src={login_user_store.tailor_user_url} style={{marginRight: '10px',width:'40px',height:'40px'}}/>
            <span style={{
              marginRight: '20px'
            }}>
              {/* 当前用户：{
              login_user_store.nick_name
            } */}
            <Dropdown overlay={ (
              <Menu>
                <Menu.Item>
                  <div onClick={() => {
                    go_to_page.goSettingPath()
                  }}>
                    <Icon type="edit" style={{
                      paddingTop: '3px',
                      marginRight: '10px',
                      float: 'left'
                    }}/>
                    <a target="_blank">修改密码</a>
                  </div>
                </Menu.Item>
                <Menu.Item>
                  <div onClick={() => {
                    confirm({
                      title: '确定退出登录？',
                      onOk: () => {
                        this.logout()
                      },
                      onCancel: () => {

                      }
                    })
                  }}>
                    <Icon type="logout" style={{
                      paddingTop: '3px',
                      marginRight: '10px',
                      float: 'left'
                    }}/>
                    <a target="_blank">退出登录</a>
                  </div>
                </Menu.Item>
              </Menu>
            )}>
              <a style={{
                color: '#fff'
              }} className="ant-dropdown-link" href="#">
                {
                  login_user_store.pet_name
                }<Icon type="down" />
              </a>
            </Dropdown>
            </span>
            {/*{*/}
              {/*login_user_store.nick_name !== login_user_store.proxy_user ? (*/}
                {/*<span >*/}
                {/*上级代理：{*/}
                {/*login_user_store.proxy_user*/}
              {/*}*/}
              {/*</span>*/}
              {/*) : null*/}
            {/*}*/}
          </Col>
          <Col span={ 12 }>
            <span style={{
              float: 'right',
            }}>
              <Button
                size={form_item_size}
                type='primary'
                onClick={() => {
                  substitute_charge_store.openModal()
                }}>代充</Button>
            </span>
            <span
              style={{
                float: 'right',
                marginRight: '20px'
              }}
              onClick={() => {
                login_user_store.fetchUserInfo();
              }}>
              {/*<span style={{*/}
              {/*  marginRight: '20px'*/}
              {/*}}>*/}
              {/*  返佣：{ login_user_store.rate } %*/}
              {/*</span>*/}
              <span>
                余额：￥{window.FormatAmount(login_user_store.balance)}
              </span>
            </span>
          </Col>
        </Row>
      </Header>
    )
  }

  componentDidMount() {
    this.setState({someKey: 'otherValue'});
  }
}

export default GlobalHeader;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/GlobalHeader.jsx